/*
 * @Author: Ashley.Liu
 * @Date: 2022-05-31 18:06:14
 * @LastEditTime: 2022-06-22 14:57:10
 * @Description: desc
 */
/* eslint-disable */
import router from './plugins/router'
import CryptoJS from 'crypto-js'
import { tokenUtil } from '@/utils/'

let url = window.location.href
if (url.indexOf('dclogin') > -1) {
  let bytes = url.split('dclogin=')[1]
  bytes = CryptoJS.AES.decrypt(bytes, 'abc13scfssawdecsd')
  const loginInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  if(loginInfo.mqval === 'shjvfsjvjdfv'){
    localStorage.username = loginInfo.username
    localStorage.role = loginInfo.role
    tokenUtil.set(loginInfo.mqtoken)
    tokenUtil.set(loginInfo.mqrefreshtoken, 'refreshToken')
    let baseurl = url.split('?')[0]
    window.history.pushState({},0,baseurl)
  }
}
router.beforeEach((to, from, next) => {
  let hasValidToken = tokenUtil.validateTokenExp(tokenUtil.getRefreshToken()) && tokenUtil.getToken()
  let role = localStorage.getItem('role')
  let path = to.path
  if (path === "/login") {
    next()
    return
  }
  if (hasValidToken) {
    // if (role === 'APP' && path === '/dashboard/auditlog') {
    //   next({
    //     path: from.path
    //   })
    //   return
    // }
    if (path) {
      next()
      return
    }
  } else {
    next({
      path: "/login"
    })
  }
})
